<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <v-progress-circular
          v-if="isEcSynchronisationStatusPending()"
          color="primary"
          width="3"
          indeterminate
        >
          <v-icon color="primary">
            {{ getEcSynchronisationStatusIcon() }}
          </v-icon>
        </v-progress-circular>
        <v-icon
          v-else
          :color="getEcSynchronisationStatusColour()"
        >
          {{ getEcSynchronisationStatusIcon() }}
        </v-icon>
      </div>
    </template>
    {{ getEcSynchronisationTooltip() }}
  </v-tooltip>
</template>

<script>
import constants from '@/constants';

export default {
  name: 'ECSynchronisationStatusIndicator',

  props: {
    status: String,
    synchronisationPendingText: {
      type: String,
      default: 'Synchronisation with EC pending.',
    },
    synchronisationFailureText: {
      type: String,
      default: 'Synchronisation with EC failed.',
    },
    synchronisationSuccessText: {
      type: String,
      default: 'Synchronised with EC.',
    },
  },

  methods: {
    isEcSynchronisationStatusPending() {
      return this.status === constants.EC_SYNCHRONISATION_STATUS.SYNCHRONISATION_PENDING;
    },

    getEcSynchronisationStatusColour() {
      switch (this.status) {
        case constants.EC_SYNCHRONISATION_STATUS.SYNCHRONISED: return 'success';
        case constants.EC_SYNCHRONISATION_STATUS.SYNCHRONISATION_PENDING: return 'primary';
        default: return 'error';
      }
    },

    getEcSynchronisationStatusIcon() {
      switch (this.status) {
        case constants.EC_SYNCHRONISATION_STATUS.SYNCHRONISED: return 'cloud_done';
        case constants.EC_SYNCHRONISATION_STATUS.SYNCHRONISATION_PENDING: return 'cloud_circle';
        default: return 'cloud_off';
      }
    },

    getEcSynchronisationTooltip() {
      switch (this.status) {
        case constants.EC_SYNCHRONISATION_STATUS.SYNCHRONISED: return this.synchronisationSuccessText;
        case constants.EC_SYNCHRONISATION_STATUS.SYNCHRONISATION_PENDING: return this.synchronisationPendingText;
        default: return this.synchronisationFailureText;
      }
    },
  },
};
</script>

<style scoped>

</style>
